import { DamageMainCode } from "../../services/damage/DamageMainCode";
import { DamageGroupCodeResponse } from "../../api-models/response/DamageGroupCodeResponse";

export class DamageGroupCode implements DamageGroupCodeResponse {
  code: string;
  text: string;
  mainCodes: DamageMainCode[];

  constructor(damageGroupCode: DamageGroupCodeResponse) {
    this.code = damageGroupCode.code;
    this.text = damageGroupCode.text;
    this.mainCodes = damageGroupCode.mainCodes.map((x) => new DamageMainCode(x));
  }

  setText(newText: string) {
    this.text = newText;
  }

  public get label() {
    return `${this.code} ${this.text}`;
  }
}

export const emptyGroupCode = new DamageGroupCode({
  code: "",
  text: "",
  mainCodes: [],
});
